// @ts-nocheck
import * as React from "react";

const Upload: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M13.001 6.986l2.4 1.807a1 1 0 00.472.191l.128.009a1 1 0 00.725-.31l.075-.09a1 1 0 00-.104-1.319l-.096-.081-4-3a1 1 0 00-1.18 0l-4 2.82a1 1 0 00-.305 1.283l.065.107a1 1 0 001.4.24l2.423-1.708-.003.058v8a1 1 0 00.884.993l.116.007a1 1 0 00.994-.884l.006-.116V6.986zM19 21a1 1 0 001-1v-2a1 1 0 00-.883-.993L19 17a1 1 0 00-1 1v1.001L6 19v-1a1 1 0 00-.883-.993L5 17a1 1 0 00-1 1v2a1 1 0 00.883.993L5 21h14z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Upload);
